import { defineComponent as _defineComponent } from 'vue'

import { contributorFullName } from '@/foundations/helpers/contributorName';

type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {



const fields = [
  {
    source: 'id',
    link: 'edit',
    sortable: false,
  },
  {
    source: 'name',
    label: 'Name',
    sortable: false,
  },
  {
    source: 'isOrganization',
    label: 'Organization',
    type: 'boolean',
    sortable: false,
  },
];

return { __sfc: true,fields, contributorFullName }
}

})